import type { StreamFrame } from './types';

const FRAME_SEPARATOR = '\n\n';
const DATA_PREFIX = 'data:';

/** The `data:` frames of a server-sent event stream, in order, until the stream closes. Comment lines (the
 *  server's keep-alive pings) and frames that don't parse are skipped. */
export async function* readFrames(body: ReadableStream<Uint8Array>): AsyncGenerator<StreamFrame> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  try {
    for (;;) {
      const { done, value } = await reader.read();
      if (done) return;
      buffer += decoder.decode(value, { stream: true });
      let end = buffer.indexOf(FRAME_SEPARATOR);
      while (end !== -1) {
        const frame = parseFrame(buffer.slice(0, end));
        buffer = buffer.slice(end + FRAME_SEPARATOR.length);
        if (frame) yield frame;
        end = buffer.indexOf(FRAME_SEPARATOR);
      }
    }
  } finally {
    reader.releaseLock();
  }
}

function parseFrame(chunk: string): StreamFrame | null {
  const data = chunk.split('\n').find((line) => line.startsWith(DATA_PREFIX))?.slice(DATA_PREFIX.length).trim();
  if (!data) return null;
  try {
    return JSON.parse(data) as StreamFrame;
  } catch {
    return null;
  }
}
